import { RatingsAndReviews } from './component/RatingsAndReviews.component';
import { CollectionReviewModel } from './component/models/CollectionReviewModel';
import { CollectionReviewsWithPresentation } from './component/CollectionReviews/CollectionReviewsWithPresentation.component';
import { Model } from './component/models/Model';
import { ReviewModel } from './component/models/ReviewModel';
import { ReviewStatsModel } from './component/models/ReviewStatsModel';
import { ReviewSentimentModel } from './component/models/ReviewSentimentModel';
import { WriteAReviewWithPresentation } from './component/WriteAReview/WriteAReviewWithPresentation.component';
import { BrandRating } from './component/BrandRating/BrandRating';
import { dataModel } from "./component/ReviewDataModel";

const WriteAReview = WriteAReviewWithPresentation;
const CollectionReviews = CollectionReviewsWithPresentation;

export {
  dataModel,
  BrandRating,
  CollectionReviewModel,
  CollectionReviews,
  Model,
  RatingsAndReviews,
  ReviewModel,
  ReviewSentimentModel,
  ReviewStatsModel,
  WriteAReview
};
